// 移动端路由守卫纯函数：路径判定与重定向目标计算（无任何依赖，可独立单测）
export const isMobilePath = (path) => path === '/mobile' || path.startsWith('/mobile/')

// 返回应重定向的目标路径；null = 放行
export const resolveMobileTarget = (toPath, token) => {
	if (toPath === '/mobile/login') {
		return token ? '/mobile/home' : null
	}
	return token ? null : '/mobile/login'
}

// 移动端可用用户类型白名单（sys_user.TYPE，与后端 MobileLoginChecker.MOBILE_ALLOWED_TYPES 保持一致）：
// '1' 监理侧（移动端全功能）；'2' 承建侧（2026-10-29 放开，仅问题管理/任务管理/我的任务三个入口）
export const MOBILE_ALLOWED_USER_TYPES = ['1', '2']

// 页面级准入：sys_user.TYPE 不在白名单内则拦截（type 经 /api/auth/b/getLoginUser 的 SaBaseLoginUser.type 返回）。
// 仅当用户信息已加载（有 id）且 type 不在白名单才判"拦截"——后端登录接口已拦 device=APP，此处兜住 PC 登录态（token
// 共用）直达 /mobile/** 的绕行；userInfo 未加载/无 id（如令牌失效 getLoginUser 未返回）不拦截，
// 维持原有 401 弹窗重新登录路径，避免把"登录过期"误报成"未开放使用"
export const isMobileUserDenied = (userInfo) => {
	return !!userInfo && !!userInfo.id && !MOBILE_ALLOWED_USER_TYPES.includes(String(userInfo.type))
}
